import React from "react";
import { makeStyles } from "@mui/styles";
import { Paper, Tab, Tabs } from "@mui/material";
import { TabPanel } from "./TabPanel";

interface TabPanelItem {
	label: string;
	child: React.ReactNode;
}

interface TabGroupProps {
	tabPanels: Array<TabPanelItem>;
	handleTabChange: (value: number) => void;
	activeTab: number;
}
const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	appBar: {
		marginTop: "10px",
		marginBottom: "10px",
		zIndex: 1,
		backGround: theme.palette.common.white,
	},
	tab: {
		padding: "6px",
		minWidth: "45px",
	},
}));

export default function TabGroup(props: TabGroupProps) {
	const classes = useStyles();
	const { tabPanels, handleTabChange, activeTab } = props;

	const handleChange = (event, value) => {
		handleTabChange(value);
	};

	return (
		<React.Fragment>
			<Paper className={classes.appBar}>
				<Tabs
					value={activeTab}
					onChange={handleChange}
					indicatorColor="secondary"
					textColor="secondary"
					variant="fullWidth"
				>
					{tabPanels.map((tab) => (
						<Tab key={tab.label} label={tab.label} className={classes.tab} />
					))}
				</Tabs>
			</Paper>
			<TabPanel key={activeTab} value={activeTab} index={activeTab}>
				{tabPanels[activeTab].child}
			</TabPanel>
		</React.Fragment>
	);
}
